import { gql } from '@apollo/client';

export const PAYROLL_COMPANIES = gql`
  query PayrollCompanies($oplId: ID) {
    payrollCompanies(state: [1], oplId: $oplId) {
      pcIdeNum
    }
  }
`;

export const GET_PRESIGNED_UPLOAD_URL = gql`
  query GetPresignedUploadUrl($oplId: ID!) {
    getPresignedUploadUrl(oplId: $oplId) {
      uploadUrl
      s3Key
    }
  }
`;

export const CREATE_BULK_UPLOAD_JOB = gql`
  mutation CreateBulkUploadJob($s3Key: String!, $oplId: ID!, $fileName: String) {
    createBulkUploadJob(s3Key: $s3Key, oplId: $oplId, fileName: $fileName) {
      jobId
      status
      createdAt
      updatedAt
    }
  }
`;

export const GET_BULK_UPLOAD_JOB_STATUS = gql`
  query GetBulkUploadJobStatus($jobId: ID!) {
    getBulkUploadJobStatus(jobId: $jobId) {
      jobId
      status
      progress {
        current
        total
        percentage
      }
      result {
        successS3Key
        errorsS3Key
        totalRows
        savedCount
        errorCount
        fileName
      }
      createdAt
      updatedAt
    }
  }
`;

export const GET_BULK_UPLOAD_JOB_ERRORS = gql`
  query GetBulkUploadJobErrors($jobId: ID!) {
    getBulkUploadJobErrors(jobId: $jobId) {
      errors {
        row
        column
        columnIndex
        value
        errorType
        message
        originalData {
          N_DOCUMENTO
          FECHA_DE_APLICACION
          N_CREDITO
          TIPO
          ATRIBUTO
          MONTO
          TIPO_PAGO
        }
      }
      errorCount
    }
  }
`;

export const GET_MY_BULK_UPLOAD_JOBS = gql`
  query GetMyBulkUploadJobs {
    getMyBulkUploadJobs {
      jobId
      status
      fileName
      progress {
        current
        total
        percentage
      }
      result {
        totalRows
        savedCount
        errorCount
        fileName
      }
      createdAt
      updatedAt
    }
  }
`;

export const GET_BULK_UPLOAD_JOB_SUCCESSES = gql`
  query GetBulkUploadJobSuccesses($jobId: ID!) {
    getBulkUploadJobSuccesses(jobId: $jobId) {
      savedCount
      records {
        row
        pcIdeNum
        cConsecutive
        dateConsignment
        transactionType
        attributeType
        amount
        paymentType
      }
    }
  }
`;

export const DELETE_BULK_UPLOAD_JOB = gql`
  mutation DeleteBulkUploadJob($jobId: ID!) {
    deleteBulkUploadJob(jobId: $jobId) {
      success
      jobId
    }
  }
`;

export const CANCEL_BULK_UPLOAD_JOB = gql`
  mutation CancelBulkUploadJob($jobId: ID!) {
    cancelBulkUploadJob(jobId: $jobId) {
      success
      jobId
    }
  }
`;

export const RETRY_BULK_UPLOAD_JOB = gql`
  mutation RetryBulkUploadJob($jobId: ID!) {
    retryBulkUploadJob(jobId: $jobId) {
      jobId
      status
    }
  }
`;
